/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Lines_LabelInputs */

const en_event_warning_lines_label = /** @type {(inputs: Event_Warning_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lines`)
};

const fr_event_warning_lines_label = /** @type {(inputs: Event_Warning_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lignes`)
};

const de_event_warning_lines_label = /** @type {(inputs: Event_Warning_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linien`)
};

const it_event_warning_lines_label = /** @type {(inputs: Event_Warning_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linee`)
};

const ru_event_warning_lines_label = /** @type {(inputs: Event_Warning_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Линии`)
};

const es_event_warning_lines_label = /** @type {(inputs: Event_Warning_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauta`)
};

const zh_cn2_event_warning_lines_label = /** @type {(inputs: Event_Warning_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`线条`)
};

const ja_event_warning_lines_label = /** @type {(inputs: Event_Warning_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`線`)
};

const hi_event_warning_lines_label = /** @type {(inputs: Event_Warning_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंक्तियां`)
};

const pt_pt2_event_warning_lines_label = /** @type {(inputs: Event_Warning_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas`)
};

/**
* | output |
* | --- |
* | "Lines" |
*
* @param {Event_Warning_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_lines_label = /** @type {((inputs?: Event_Warning_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_warning_lines_label(inputs)
	if (locale === "de") return de_event_warning_lines_label(inputs)
	if (locale === "it") return it_event_warning_lines_label(inputs)
	if (locale === "ru") return ru_event_warning_lines_label(inputs)
	if (locale === "es") return es_event_warning_lines_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_warning_lines_label(inputs)
	if (locale === "ja") return ja_event_warning_lines_label(inputs)
	if (locale === "hi") return hi_event_warning_lines_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_warning_lines_label(inputs)
	return en_event_warning_lines_label(inputs)
});